<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-8'">
    <div class="title text--secondary">
      Dashboard
    </div>
    <v-row>
      <v-col
        cols="12" md="3"
        v-for="(l, index) in countTop"
        :key="index">
        <v-card
          class="mx-auto c-p"
          :outlined="selected !== l.id"
          :elevation="selected === l.id ? 5 : 0 "
          @click="toFilter(l)">
          <v-list-item 
          three-line
          elevation="0">
            <v-list-item-content>
              <div class="body-2 text--secondary mb-4">
                {{ l.name }}
              </div>
              <v-list-item-title class="headline font-weight-bold text--secondary mb-1">
                <span v-if="process.run">0</span>
                <span v-if="!process.run">
                  <span v-if="l.id === 1">
                    {{ result.countUsers }}
                  </span>
                  <span v-if="l.id === 2">
                    {{ result.countClasses }}
                  </span>
                  <span v-if="l.id === 3">
                    {{ result.countTransaction }}
                  </span>
                  <span v-if="l.id === 4">
                    {{ result.totalTransactionPrice | price }}
                  </span>
                </span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar
              class="pa-2"
              size="30"
              style="border-radius: 5px; box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;"
              color="#ff618a">
              <v-icon small color=white>{{ l.icon }}</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8">
        <v-card>
           <v-row>
            <v-col>
              <div class="body-1 font-weight-bold text--secondary px-5 pt-2 pb-0">
                Grafik {{ filter.name }}
              </div>
              <v-divider class="ma-3 my-1"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <div>
              <v-select
                outlined
                dense
                color="#ff618a"
                v-model="selectFilter"
                :class="$vuetify.breakpoint.name === 'xs' ? 'ma-3' : 'ml-3'"
                :items="sort.submenu"
                item-value="value"
                item-text="text"
                hide-details
                v-on:change="changesFilter()"
                label="Filter">
              </v-select>
            </div>
            </v-col>
            <v-col cols="12" sm="8">
            <div            
            class="mx-2 c-p" >
              <v-chip
              class="ma-2"
              v-if="chip.chipYear"
              close
              @click:close="chip.chipYear = false; filter.years = 2020;selectFilter =''; fetchChart()">
              {{ filter.years }}
              </v-chip>
              <v-chip
              class="ma-2"
              v-if="chip.chipMonth"
              close
              @click:close="chip.chipMonth = false; filter.month = 'semua';selectFilter =''; fetchChart()">
              {{ filter.month }}
              </v-chip>
            </div>
            <div v-if="selectFilter === 'range' ">
              <v-row justify="center" align="center">
                <v-col cols="12" sm="5" class="py-0">
                  <v-menu
                    ref="menustart"
                    v-model="menu.menuStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    class="z-my"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filter.startDate"
                      label="Tanggal Mulai"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      color="#ff618a"
                      v-on="on">
                    </v-text-field>
                    </template>
                    <v-date-picker 
                    v-model="filter.startDate"  
                    color="#ff618a"
                    @input="menu.menuStart = false">
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="5" class="py-0">
                  <v-menu
                    ref="menuend"
                    v-model="menu.menuEnd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    class="z-my"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filter.endDate"
                      label="Tanggal Selesai"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      color="#ff618a"
                      :disabled="filter.startDate === ''"
                      v-on="on"
                      >
                    </v-text-field>
                    </template>
                    <v-date-picker 
                    v-model="filter.endDate" 
                    :min="filter.startDate" 
                    color="#ff618a"
                    @input="menu.menuEnd = false">
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="2" class="py-0">
                    <v-btn 
                      fab 
                      small
                      color="#ff618a"
                      elevation="0"
                      class="text-capitalize white--text"
                      :disabled="filter.endDate === ''"
                      @click="fetchChart();">
                      <v-icon small>mdi-calendar-search</v-icon>
                    </v-btn>
                  </v-col>
              </v-row>
            </div>
            <div :class="$vuetify.breakpoint.name === 'xs' ? 'mt-1' : 'mt-4'">
              <v-select
                v-if = "selectFilter === 'year'"
                outlined
                dense
                color="#44b985"
                label="Tahun"
                class="my-3 mx-3  z-my"
                :hide-details="true"
                :items="yearstart"
                v-model="filter.years"
                v-on:change="changeYears"
                require>
              </v-select>
            </div>
            <div class="mt-4">
              <v-select
                v-if = "selectFilter === 'month'"
                outlined
                dense
                color="#44b985"
                label="Bulan"
                class="my-3 mx-3  z-my"
                :hide-details="true"
                :items="SelectedMonths"
                v-model="filter.month"
                v-on:change="changeMonth"
                require>
              </v-select>
            </div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="4">
              <div 
                v-if="process.chart" 
                class="text-center" 
                style="padding-top: 10rem; padding-bottom: 10rem;">
                <p class="title gt mt-8 mb-5">
                  Menunggu data . . .
                </p>
                <v-progress-linear
                  color="#ff618a"
                  indeterminate
                  rounded
                  height="6">
                </v-progress-linear>
              </div>
            </v-col>
          </v-row>
          <div class="mt-8" v-if="!process.chart">
            <apexchart height="500" :options="bar.chartOptions" :series="bar.series"></apexchart>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <div class="background-default pa-5">
          <div class="body-2 font-weight-bold grey--text text--darken-2 mb-1">
            Kelas yang paling sering dibeli
          </div>
          <v-divider class="mb-2"/>
          <v-skeleton-loader
            light
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:listClass"
            :key="index">
            <router-link :to="`/class/${l.id}`" 
              style="text-decoration: unset;">
              <v-list dense style="background: transparent;" class="py-0">
                <v-list-item
                  class="mt-0 px-0">
                  <v-list-item-avatar tile style="border-radius: 5px; box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                    <img style="border-radius: 5px;" :src="l.classesUrlCover">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                      {{ l.classesTitle }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="cption">
                      {{ l.classesCategoryTitle }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content class="text-right">
                    <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                      {{ l.classesJoin }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </router-link>
          </v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import moment from 'moment';
  export default {
    data() {
      return {
        bar: {
          series: [],
          chartOptions: {
            chart: {
              animations: {
                enabled: true,
                easing: "linear",
                dynamicAnimation: {
                  speed: 1000
                }
              },
              toolbar: {
                show: true
              },
              zoom: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "smooth"
            },
            colors:["#ff618a"],
            xaxis: {
              categories: []
            }
          }
        },
        readonly: false,
        panel: [0],
        selectedPage:'',
        year: {
          start: new Date().getFullYear()
        },
        selectFilter:'',
        SelectedMonths: ["semua", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        selected: 1,
        countTop: [
          {
            id: 1,
            text: 'user',
            name: 'Total Pengguna',
            icon: 'mdi-account-multiple'
          },
          {
            id: 2,
            text: 'class',
            name: 'Total Kelas',
            icon: 'mdi-home-city'
          },
          {
            id: 3,
            text: 'transaction',
            name: 'Total Transaksi',
            icon: 'mdi-wallet'
          },
          {
            id: 4,
            text: 'selling',
            name: 'Total Penjualan',
            icon: 'mdi-cash-usd-outline'
          }
        ],
        sort:{
          submenu:[
            {
              value:'year',
              text:'Years',
            },
            {
              value:'month',
              text:'Month',
            },
            {
              value:'week',
              text:'Week',
            },
            {
              value:'days',
              text:'Days',
            },
            {
              value:'range',
              text:'Range',
            }
          ]
        },
        result: {},
        listClass: [],
        days: false,
        menu:{
          menuStart:false,
          menuEnd:false
        },
        chip:{
          chipYear: false,
          chipMonth: false
        },
        filter: {
          type:'user',
          years: 2020,
          month: 'semua',
          day: moment().format('YYYY-MM-DD'),
          name: 'Total Pengguna',
          week: '',
          startDate: '',
          endDate:''
        },
        process: {
          run: false,
          chart: false
        },
        response: ''
      }
    },
    computed: {
      yearstart () {
        let start = []
        for (let i = this.year.start; i>=this.year.start - 50; i-=1) {
          start.push(i)
        }
        return start
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
      this.fetchChart()
      this.fetchClass()
    },
    methods: {
      async fetch() {
        this.process.run = true
        await get(`api/internal/dashboard`)
        .then((response) => {
          let res =response.data
          if (res.code === 200) {
            this.process.run = false
            this.result = res.data
          }
        })
      },
      async fetchClass() {
        this.process.run = true
        await get(`api/internal/class/popular`)
        .then((response) => {
          let res =response.data
          if (res.code === 200) {
            this.process.run = false
            this.listClass = res.data
          }
        })
      },
      async fetchChart() {
        this.process.chart = true
        let params = {}
        if(this.filter.week === 'yes'){
          params = {
            type: this.filter.type,
            week: this.filter.week
          }
        }else if(this.days){
          params = {
            type: this.filter.type,
            day: this.filter.day
          }
        }else if(this.selectFilter === 'range'){
            params = {
              type: this.filter.type,
              start: this.filter.startDate,
              end: this.filter.endDate,
            }
        }
        else{
          params = {
            type: this.filter.type,
            year: this.filter.years,
            week: this.filter.week,
            month: this.filter.month === 'January' ? '01' : this.filter.month === 'February' ? '02' : this.filter.month === 'March' ? '03' : this.filter.month === 'April' ? '04' : this.filter.month === 'May' ? '05' : this.filter.month === 'June' ? '06' : this.filter.month === 'July' ? '07' : this.filter.month === 'August' ? '08' : this.filter.month === 'September' ? '09' : this.filter.month === 'October' ? '10' : this.filter.month === 'November' ? '11' : this.filter.month === 'December' ? '12' : ''
          }          
        }
        await get(`api/internal/chart`, {
          params: params 
        })
        .then((response) => {
          let res =response.data
          if (res.code === 200) {
            this.process.chart = false
            if (this.filter.month === 'semua') {
              this.bar.chartOptions.xaxis.categories = this.months
            } else {
              this.bar.chartOptions.xaxis.categories = res.data 
            }
            this.bar.series= [
              {
                name: this.selected === 1 ? 'Pengguna' : this.selected === 2 ? 'Kelas' : this.selected === 3 ? 'Transaksi' : 'Penjualan',
                data: res.count
              }
            ]
          }
        })
      },
      fetchRange(){
          this.filter.month = ''
          this.chip.chipYear = false
          this.chip.chipMonth = false
          this.fetchChart()
      },
      changesFilter(){
        if(this.selectFilter === 'week'){
          this.filter.week = 'yes'
          this.filter.month=''
          this.selectedPage = ''
          this.chip.chipYear = false
          this.chip.chipMonth = false
          this.fetchChart()
        }else if(this.selectFilter === 'days'){
          this.filter.week = ''
          this.filter.month=''
          this.selectedPage = ''
          this.days = true
          this.fetchChart()
        }else if(this.selectFilter === 'year'){
          this.filter.month='semua'
          this.fetchChart()
        }else if(this.selectFilter === 'month'){
          this.filter.month='semua'
          this.fetchChart()
        }else if(this.selectFilter === 'range'){
          this.fetchRange()
        }
      },
      toFilter(item) {
        this.selected = item.id
        this.filter.type = item.text
        this.filter.name = item.name
        this.fetchChart()
      },
      changeYears() {
        this.chip.chipYear = true
        // this.filter.month = ''
        this.fetchChart()
      },
      changeMonth() {
        this.chip.chipMonth = true
        this.fetchChart()
      }
    }
  }
</script>

<style>
  .theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line {
    background: transparent !important;
  }
  .z-my{
    z-index: 99 !important;
  }
  .bs-dashboard:hover{
    box-shadow: 0px 5px 15px -5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 5px;
  }
  .text-transform-none{
    text-transform:none !important;
  }
  .gt{
    color:#ff618a;
  }
</style>